export const defaultTypeOfCache = "default";
